export default "__VITE_ASSET__BVQFdSmV__"